import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';

const CustomPaginator = ({ first, rows, totalRecords, onPageChange }) => {
  const totalPages = Math.ceil(totalRecords / rows);
  const currentPage = Math.floor(first / rows) + 1;

  const handlePrev = () => {
    if (currentPage > 1) {
      onPageChange({ first: first - rows, rows });
    }
  };

  const handleNext = () => {
    if (currentPage < totalPages) {
      onPageChange({ first: first + rows, rows });
    }
  };

  return (
    <div className="custom-paginator">
      <span onClick={handlePrev} disabled={currentPage === 1} className="paginator-button">
        <FontAwesomeIcon icon={faChevronLeft} />
      </span>
      <span className="paginator-info">
        {currentPage} / {totalPages}
      </span>
      <span onClick={handleNext} disabled={currentPage === totalPages} className="paginator-button">
        <FontAwesomeIcon icon={faChevronRight} />
      </span>
    </div>
  );
};

export default CustomPaginator;
